'use es6';

export var ALERT_TYPES = {
  info: 'alert-info private-alert--info',
  warning: 'alert-warning private-alert--warning',
  success: 'alert-success private-alert--success',
  danger: 'alert-danger private-alert--danger',
  tip: 'private-alert--tip'
};
export var ALERT_USES = {
  default: '',
  inline: 'private-alert--inline'
};